export default {
  webhooks: [],
  webhookTypes: [],
  webhookLogs: {
    data: [],
    links: {
      first: '',
      last: '',
      prev: '',
      next: '',
    },
    meta: {
      current_page: 1,
      from: 1,
      last_page: 1,
      path: '',
      per_page: 0,
      to: 1,
      total: 0,
    },
  },
  webhooksLoaded: false,
  webhookTypesLoaded: false,
  webhookLogsLoaded: false,
  webhookSaved: false,
  webhookDeleted: false,
  apiError: {},
};
